export default "__VITE_ASSET__CTRuixQl__"